export const QUANTIDADE_DESTINOS_PING = 5;

// Função para gerar os nomes das macros: {$DESTINO_A}, {$DESTINO_B}, etc.
export const gerarNomesMacros = (quantidade) => {
  const macros = [];
  for (let i = 0; i < quantidade; i++) {
    // 65 é o charCode para 'A'
    const letra = String.fromCharCode(65 + i);
    macros.push(`{$DESTINO_${letra}}`);
  }
  return macros;
};

// Gera os nomes das macros de origem: {$ORIGEM_A}, {$ORIGEM_B}, etc.
export const gerarNomesMacrosOrigem = (quantidade) => {
  const macros = [];
  for (let i = 0; i < quantidade; i++) {
    const letra = String.fromCharCode(65 + i);
    macros.push(`{$ORIGEM_${letra}}`);
  }
  return macros;
};

export const MACRO_PING_HABILITADO = "{$PING_HABILITADO}";
export const MACROS_DESTINO = gerarNomesMacros(QUANTIDADE_DESTINOS_PING);
export const MACROS_ORIGEM = gerarNomesMacrosOrigem(QUANTIDADE_DESTINOS_PING);

// Lista com os destinos padrão e extras caso a quantidade seja aumentada
export const DESTINOS_PADRAO_COMPLETO = [
  { valor: "8.8.8.8", descricao: "Google", origem: "" },
  { valor: "208.67.222.222", descricao: "Open DNS", origem: "" },
  { valor: "1.1.1.1", descricao: "Cloudflare", origem: "" },
  { valor: "globo.com", descricao: "Globo", origem: "" },
  { valor: "200.160.0.8", descricao: "NTP", origem: "" },
];

export const getDestinosPadrao = (quantidade) => {
  const destinos = [];
  for (let i = 0; i < quantidade; i++) {
    if (i < DESTINOS_PADRAO_COMPLETO.length) {
      destinos.push({ ...DESTINOS_PADRAO_COMPLETO[i] });
    } else {
      destinos.push({ valor: "", descricao: "", origem: "" });
    }
  }
  return destinos;
};
